import React from 'react'
import PropTypes from 'prop-types'
import './SkipLink.scss'

/**
 * SkipLink - Accessibility component for keyboard users to skip to main content
 *
 * @param {string} targetId - ID of the element to skip to
 * @param {string} label - Link label text
 */
const SkipLink = ({ targetId = 'main-content', label = 'Skip to main content' }) => {
	const handleClick = (e) => {
		e.preventDefault()
		const target = document.getElementById(targetId)
		if (target) {
			target.focus()
			target.scrollIntoView({ behavior: 'smooth' })
		}
	}

	return (
		<a
			href={`#${targetId}`}
			className="skip-link"
			onClick={handleClick}
		>
			{label}
		</a>
	)
}

SkipLink.propTypes = {
	targetId: PropTypes.string,
	label: PropTypes.string
}

export default SkipLink
